import React from 'react';
import { useTranslation } from 'react-i18next';
import { GoogleMap, Polygon, useLoadScript } from '@react-google-maps/api';
import { getColor } from '@panel/commons/core/themev3';
import { Container, ZoneDemandListContainer, MapContainer, Title } from './styles';
import { zoomMap, centerMap, markersCenter, polygonsZones } from '../../../helpers/DataMapsInfo/getDataMapsInfo';
import CustomMarkers from './Markers';
import ZoneDemandList from '../../ZoneDemandList.js';

const MapSection = ({ device, handleClick, mapRef, plansRef }) => {
  const { t } = useTranslation();
  const siteId = process.env.REACT_APP_BUILD_SITE;

  const getHeightMap = () => {
    if (device === 'mobile') return '480px';
    if (device === 'tablet') return '340px';
    return '528px';
  };

  const mapContainerStyle = {
    height: getHeightMap(),
    width: '100%'
  };

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_KEY
  });

  const optionsPolygon = {
    fillColor: getColor('primary'),
    fillOpacity: 0.1,
    strokeColor: getColor('primary'),
    strokeOpacity: 1,
    strokeWeight: 1,
    clickable: false,
    draggable: false,
    editable: false,
    geodesic: false
  };

  return (
    <Container device={device} data-panel='landingZD-mapSection-container' ref={device !== 'mobile' ? mapRef : null}>
      {device === 'mobile' && <div className='ref-scroll' ref={mapRef} />}
      {device !== 'desktop' && (
        <Title device={device} data-panel='landingZD-mapSection-title'>
          {t('panel.landing_ZD.maps.title')}
        </Title>
      )}
      <MapContainer device={device} data-panel='landingZD-mapSection-googleMaps'>
        {!isLoaded && <div className='loading'>Loading Map</div>}
        {isLoaded && (
          <GoogleMap
            id='map-zonaDemand'
            mapContainerStyle={mapContainerStyle}
            zoom={device === 'mobile' ? zoomMap[siteId].mobile : zoomMap[siteId].regular}
            center={centerMap[siteId]}
            options={{ streetViewControl: false, mapTypeControl: false }}
          >
            {polygonsZones(siteId)?.map((polygon, i) => (
              <Polygon key={i.toString()} paths={polygon.paths} options={optionsPolygon} />
            ))}
            {markersCenter[siteId]?.map((coordinatesMarker, i) => (
              <CustomMarkers key={i.toString()} coordinates={coordinatesMarker} />
            ))}
          </GoogleMap>
        )}
      </MapContainer>
      <ZoneDemandListContainer device={device} data-panel='landingZD-ZoneDemandList-container'>
        <ZoneDemandList device={device} handleClick={handleClick} plansRef={plansRef} siteId={siteId} />
      </ZoneDemandListContainer>
    </Container>
  );
};

export default MapSection;
